import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 上下文分析结果展示组件
 * 以卡片形式展示分析结果，支持加载和空状态
 */
export const ContextAnalysisView = ({ analysisText, isLoading = false, className = '', }) => {
    const renderAnalysisContent = () => {
        if (isLoading) {
            return _jsx("span", { className: "text-gray-500 italic", children: "Analyzing..." });
        }
        if (!analysisText) {
            return _jsx("span", { className: "text-gray-500 italic", children: "No contextual analysis available." });
        }
        return analysisText;
    };
    return (_jsxs("div", { className: `bg-white rounded-lg shadow-md p-0.5 flex flex-col ${className}`, children: [_jsx("h3", { className: "text-sm font-medium text-interactive-stone-gray mb-1", children: "Contextual Meaning" }), _jsx("div", { className: "bg-static-sea-blue-50 rounded-lg p-0.5 border border-static-sea-blue-200 overflow-y-auto flex-1 min-h-0", children: _jsx("div", { className: "text-sm text-interactive-stone-gray whitespace-pre-wrap", children: renderAnalysisContent() }) })] }));
};
// 添加默认导出以兼容旧代码
export default ContextAnalysisView;
//# sourceMappingURL=ContextAnalysisView.js.map